import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { WaitlistForm } from "@/components/WaitlistForm";

const perks = [
  "Founders Edition pricing — $79 (reg. $99)",
  "First production run, ships Q4 2026",
  "Free ultra-thin stylus refill for a year",
  "30-day risk-free returns",
];

export const PreorderCTA = () => (
  <section id="preorder" data-testid="preorder-section" className="py-24 md:py-32">
    <div className="max-w-5xl mx-auto px-6 md:px-10">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        className="rounded-[2rem] border border-stone-200 bg-white p-10 md:p-16 shadow-[0_30px_60px_rgba(0,0,0,0.06)]"
      >
        <p className="text-xs tracking-[0.25em] uppercase font-bold text-stone-500 mb-6">Reserve now</p>
        <h2 className="font-serif text-4xl md:text-6xl tracking-tight leading-tight text-stone-900 max-w-xl">
          Own the case that carries its own <span className="italic">precision.</span>
        </h2>
        <div className="mt-10 grid md:grid-cols-2 gap-10 items-start">
          <div className="space-y-4">
            {perks.map((p) => (
              <div key={p} className="flex items-start gap-3" data-testid="preorder-perk">
                <span className="mt-1 flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center" style={{ backgroundColor: "#E63946" }}>
                  <Check className="w-3 h-3 text-white" strokeWidth={3} />
                </span>
                <span className="text-stone-700">{p}</span>
              </div>
            ))}
          </div>
          <div>
            <p className="text-stone-600 mb-5">
              Secure your spot — refundable, no charge until we ship.
            </p>
            <WaitlistForm plan="Founders Edition — $79" compact />
          </div>
        </div>
      </motion.div>
    </div>
  </section>
);
